var _a;
import { Bill_Claim_Category } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Bill_Claim_Category.Dental] = 'Dental',
    _a[Bill_Claim_Category.Medical] = 'Medical',
    _a[Bill_Claim_Category.Pharmacy] = 'Pharmacy',
    _a[Bill_Claim_Category.Vision] = 'Vision',
    _a);
export var BillClaimCategoryEnum = {
    name: 'Bill_Claim_Category',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
